<div class="astral-stack-m">
  @for (group of formGroups; track group.controls['rowKey'].value; let i = $index) {
    <section class="astral-section-surface astral-section-surface--compact">
      <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" alignItems="center">
        <astral-select
          class="astral-grid-span-2"
          [control]="group.controls['lettingFeatureId']"
          [itemsSource]="getFeatureSelectionItems(group)"
        ></astral-select>
        <astral-checkbox [control]="group.controls['isIncluded']"></astral-checkbox>
        <div class="astral-form-adjacent-action astral-form-adjacent-action--end">
          <astral-button
            variant="secondary"
            size="small"
            type="button"
            icon="trash"
            labelKey="DELETE_BTN"
            (click)="removeFeature(i)"
          ></astral-button>
        </div>
      </astral-layout-group>
    </section>
  }

  <astral-button
    variant="primary"
    size="small"
    type="button"
    icon="plus"
    labelKey="RENTAL_OBJECT.LETTING_FEATURES.ADD_LETTING_FEATURE"
    (click)="addFeature()"
  ></astral-button>
</div>
